module.exports = __webpack_public_path__ + "img/im_scrollfeature_15.06f5f3d6.jpg";